import { useEffect, useState } from "react";
//components
import Label from "@components/ui/labels/Label";
import { SelectContainer } from "@components/ui/layout/SelectContainer";
import Select from "react-select";
import { Button } from "@components/ui/buttons/Button";
//hooks
import useRunOptions from '@hooks/useRunOptions';
import useConfirmDialog from "@hooks/useConfirmDialog";
import { useSuccess } from "@contexts/SuccessContext";
import { useError } from "@contexts/ErrorContext";
import { useLoading } from "@contexts/LoadingContext";
import { useUnsavedChanges } from '@contexts/UnsavedChangesContext';
//api
import { archiveRun } from "@services/runsAPI";

/**
 * 
 * @param {DropdownOption} selectedJob
 * 
 * @returns {JSX.Element}
 * 
 * @category Components - Job Control
 */
export const ArchiveRun = ({ selectedJob }) => {
    const { timeoutSuccess } = useSuccess();
    const { showError } = useError();
    const { showLoading, hideLoading } = useLoading();
    const [ConfirmDialog, requestConfirm] = useConfirmDialog()
    const { fetchRuns, runNameOptions } = useRunOptions();
    const [selectedRun, setSelectedRun] = useState(null)
    const {setHasUnsavedChanges} = useUnsavedChanges()

    //fetch runs when component loads or if job selected/changed
    useEffect(() => {
        
        if(!selectedJob) return 

        fetchRuns(selectedJob.value)

        //if job changes, reset runs
        setSelectedRun(null)

    }, [selectedJob]) //eslint-disable-line

    const handleArchiverunClick = async() => {
        try {
            const isConfirmed = await requestConfirm("Are you sure you want to archive this run?", 'Archive Run', 'Cancel');   
            if(!isConfirmed) return

            //confirmed
            showLoading('Archiving Run');
            
            let response = await archiveRun(selectedRun.value);

            if(response && response.success){
                hideLoading();
                timeoutSuccess('Run Has Been Archived');
            } else {
                hideLoading();
                showError(`Error Archiving Run - ${response.message}`);
            }

        } catch (error) {
            console.log(error)
            showError(`Error Archiving Run - ${error.message}`);
        } finally {
            hideLoading();
            setHasUnsavedChanges(false);
        }
    }


    return (
        <div className='martrak-max-width'>
            {selectedJob ?
                (
                    <>
                        {/* run dropdown */}
                        <Label htmlFor='runDropdown'>Select run</Label>

                        <SelectContainer>
                            <Select
                                value={selectedRun}
                                options={runNameOptions}
                                name="runDropdown"
                                onChange={(x) => setSelectedRun(x)}
                                menuPosition='fixed'
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </SelectContainer>

                        {selectedRun &&
                            <Button
                                onClick={handleArchiverunClick}
                            >Archive Run</Button>
                        }
                        <ConfirmDialog />
                    </>
                ) : (
                <div className='flex justify-center mt-10'>
                    <p className='text-purple-600 font-bold italic'>Please select a job.</p>
                </div>
                )
            }
        </div>
    )
}